// extracted by mini-css-extract-plugin
module.exports = {"productName":"XZcR6","bottomGutter":"usz8p","horizontalTextAlign":"-z-qM","verticalTextAlign":"S8HtR"};